/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';

/**
 * 
 * @export
 * @interface EnveloppeProjetFinancementSearch
 */
export interface EnveloppeProjetFinancementSearch {
    /**
     * 
     * @type {StringListSearch}
     * @memberof EnveloppeProjetFinancementSearch
     */
    idanneeScolaire?: StringListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof EnveloppeProjetFinancementSearch
     */
    identite?: Int32ListSearch;
    /**
     * 
     * @type {number}
     * @memberof EnveloppeProjetFinancementSearch
     */
    idprojetFinancement?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnveloppeProjetFinancementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof EnveloppeProjetFinancementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof EnveloppeProjetFinancementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnveloppeProjetFinancementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof EnveloppeProjetFinancementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EnveloppeProjetFinancementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the EnveloppeProjetFinancementSearch interface.
 */
export function instanceOfEnveloppeProjetFinancementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EnveloppeProjetFinancementSearchFromJSON(json: any): EnveloppeProjetFinancementSearch {
    return EnveloppeProjetFinancementSearchFromJSONTyped(json, false);
}

export function EnveloppeProjetFinancementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnveloppeProjetFinancementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeScolaire': !exists(json, 'idanneeScolaire') ? undefined : StringListSearchFromJSON(json['idanneeScolaire']),
        'identite': !exists(json, 'identite') ? undefined : Int32ListSearchFromJSON(json['identite']),
        'idprojetFinancement': !exists(json, 'idprojetFinancement') ? undefined : json['idprojetFinancement'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function EnveloppeProjetFinancementSearchToJSON(value?: EnveloppeProjetFinancementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeScolaire': StringListSearchToJSON(value.idanneeScolaire),
        'identite': Int32ListSearchToJSON(value.identite),
        'idprojetFinancement': value.idprojetFinancement,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

